<template>
  <div class="public-text-warning flex flex-align-items-start mt-15 color-primary">
    <vz-icon name="alert-circle-outline" variant="primary" size="18" class="mr-5"/>
    <slot />
  </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss" scoped>
.public-text-warning {
  .vz-icon {
    margin-top: 3px;
  }
}
</style>
